<template>
    <div class="page__bd_spacing">
        <!-- 头部 -->
        <div class="cells" style="margin-top:0px">

            <van-cell class="user-head" :title="user && user.user_id?user.user_name:'立即登录'" center :label="mobile?mobile:''" @click="bindShowInfo('info')" is-link>
                <template #icon>
                    <img  class="head"  :src="user && user.photo?user.photo+'?x-oss-process=style/w128-h128':default_head"/>
                </template>
            </van-cell>
        </div>
        <!-- 操作 -->
        <div class="cells" style="padding: 0;">

            <!--<van-cell title="学习中心" is-link @click="bindNav('learning_center/index')">-->
                <!--<template #icon>-->
                    <!--<span class="iconfont iconxuexizhongxin mr5 color-1296db"></span>-->
                <!--</template>-->
            <!--</van-cell>-->

            <van-cell v-if="train_type==1" title="我的积分" is-link @click="bindNav('integral_detail/index')">
                <template #icon>
                    <span class="iconfont iconjifen mr5 color-ff4d08"></span>
                </template>
            </van-cell>

            <van-cell v-if="train_type==1" title="排行榜" is-link @click="bindNav('integral/index')">
                <template #icon>
                    <span class="iconfont iconpaihangbang mr5 color-327CE9"></span>
                </template>
            </van-cell>

            <van-cell title="收藏夹" is-link @click="bindNav('my_collect/index')">
                <template #icon>
                    <span class="iconfont iconcollection-b mr5 color-f9ab07"></span>
                </template>
            </van-cell>

            <van-cell title="消息通知" is-link @click="bindNav('news/index')">
                <template #icon>
                    <span class="iconfont iconxiaoxi1 mr5 color-649EFF"></span>
                </template>

                <badge_dot :is_show="!params.hasUnreadMessage" :size="8" style="top: 8px;right: 0;"></badge_dot>
            </van-cell>

            <van-cell v-if="train_type==1" title="优惠券" is-link @click="bindNav('coupon/my_coupon')">
                <template #icon>
                    <span class="iconfont iconyouhuiquan mr5 color-ff4d08"></span>
                </template>
            </van-cell>

            <van-cell v-if="train_type==1" title="推广大使" is-link @click="bindNav('my_share/index')">
                <template #icon>
                    <span class="iconfont iconzhuanfa mr5 color-327CE9"></span>
                </template>
            </van-cell>

            <van-cell title="播放记录" is-link @click="bindNav('play_record/index')">
                <template #icon>
                    <span class="iconfont iconjilu mr5 color-6ed455"></span>
                </template>
            </van-cell>
            
            <van-cell title="退出登录" is-link @click="bindLogut">
                <template #icon>
                    <span class="iconfont icontuichu mr5 color-515151"></span>
                </template>
            </van-cell>
            <van-cell v-if="is_show_version" title="关于我们" is-link @click="bindNav('user/about')">
                <template #icon>
                    <span class="iconfont iconguanyu mr5 color-327CE9"></span>
                </template>
            </van-cell>
            <van-cell v-if="this.util.is_gate_user" title="测试入口" is-link @click="bindNav('test/subscribe')">
                <template #icon>
                    <span class="iconfont iconguanyu mr5 color-327CE9"></span>
                </template>
            </van-cell>
        </div>
    </div>
</template>

<script>
    import { Dialog ,Cell} from 'vant';
    import badge_dot from '../../components/common/badge_dot';

    export default {
        name: "index",
        components:{
            [Cell.name]:Cell,
            badge_dot
        },
        data(){
            return {
                medal_open:'',
                medal_list:[],
                user:{},
                default_head:require('../../assets/icon/default_head.png'),
                params:{},
                is_show_version: 0,
                train_type:1,// 1: 面向企业，2:面向学校
                train_school:['yxqqnn0500000005'],
                mobile: ''
            }
        },
        mounted() {
            this.util.hideOptionMenu();

            this.$(document).attr('title','个人中心');
            if(process.env.NODE_ENV!='production'){
                this.is_show_version = 1
            }
            console.log("111", this.util.G_CONFIG)
            if(this.util.G_CONFIG && this.util.G_CONFIG.yjy_school && this.util.G_CONFIG.yjy_school.school_id){
              this.train_type = 2
            }            
        },
        activated(){

            if(this.util.globalData.user.get() == '' && this.util.sessionid.get() != ''){
                this.util.server.mini_user.info({
                    callback: (res => {
                        this.util.globalData.user.set(res.data);
                        this.util.getUserId.set(res.data.user_id);
                        this.util.user_mobile.set(res.data.mobile);
                        this.user=this.util.globalData.user.get();
                        this.mobile = res.data.mobile
                    })
                })
            }else{
                this.user=this.util.globalData.user.get();
            }
            this.mobile = this.util.user_mobile.get();

            var _self=this;
            this.util.server.mini_message.has_home_unread({
                is_show_load:false,
                callback:function (res) {
                    _self.params = res.data;
                }
            })
        },
        methods:{
            bindShowInfo(link){
                if(!this.util.isLogin()){
                    return false;
                }

                location.href = this.util.urlPrefix+'/user/'+link+'?token='+this.util.token;
            },
            bindNav: function (link) {

                if(this.util.sessionid.get() == ''){
                    Dialog.confirm({
                        title: '提示',
                        message: '需要登录才能查看，确定登录？',
                    }).then(() => {
                        location.href= this.util.getUnifiedUrl()+'?token='+this.util.token+'&redirect='+encodeURIComponent(location.href);
                        
                    }).catch(() => {
                        // on cancel
                    });
                    return false;
                }

                this.$router.push(this.util.urlPrefix+'/'+link+'?token='+this.util.token);

                // this.util.carouselUrl('pages/'+link+'/index');
            },
            bindLogut: function(e){
                var _self=this;
                if(this.util.sessionid.get() == ''){
                    return this.util.showToast({
                        message:'请先登录'
                    });
                }
                Dialog.confirm({
                    title: '提示',
                    message: '确定要退出登录吗？',
                }).then(() => {
                    // on confirm
                    this.util.getUserId.set('');
                    this.util.sessionid.set('');
                    this.util.user_mobile.set('');
                    this.util.globalData.user.set('');
                    this.user={}
                }).catch(() => {
                    // on cancel
                });
            },
        }
    }
</script>

<style scoped>
    body{
        background-color: #f8f9fb;
    }
    .page__bd_spacing {
        padding: 15px;
    }

    .head-bg {
        height: 160px;
        background-color: #327ce9;
        background: linear-gradient(180deg, #327ce9 0%, #6296e5 100%);
        position: absolute;
        top: 0;
        width: 100%;
        z-index: -1;
    }


    .user-head {
        padding: 25px 0;
        background-color: #fff;
        box-sizing: border-box;
    }

    .head {
        width: 60px;
        height: 60px;
        margin-right: 15px;
        border-radius: 50%;
        overflow: hidden;
    }

    img {
        width: 100%;
        height: 100%;
    }

    .head img {
        border-radius: 50%;
        background-color: #999;
    }

    .user-head .name {
        color: #3A3A3A;
        font-size: 20px;
        font-weight: 800;
        line-height: 28px;
    }

    .user-head .desc {
        color: #3A3A3A;
        font-size: 11px;
        font-weight: 400;
        line-height: 17px;
    }

    .user-head .weui-cell__opr:after {
        height: 10px;
        width: 10px;
        border-width: 2px 2px 0 0;
        border-color: #fff;
        right: 30px;
    }

    .medal_open::after {
        border-width: 0 1px 1px 0;
    }

    .scroll-view_H {
        width: 100%;
        height: 50px;
        white-space: nowrap;
    }

    .scroll-view_H img {
        width: 50px;
        height: 50px;
        margin: 0 10px;
    }

    .medal {
        text-align: center;
    }

    .medal img {
        width: 85px;
        height: 85px;
        margin-bottom: 10px;
        margin-top: 30px;
    }


    .yuan {
        border: 1px solid #3a3a3a;
        border-radius: 50%;
        padding-left: 4px;
        line-height: 1;
        box-sizing: border-box;
    }

    .yuan img {
        width: 8px;
        height: 8px;
    }
    .mr5{
        margin-right: 5px;
    }
    .color-ff4d08{
        color: #ff4d08;
    }
    .color-f9ab07{
        color:#f9ab07;
    }
    .color-327CE9{
        color: #327CE9;
    }
    .color-6ed455{
        color: #6ed455;
    }
    .color-515151{
        color: #515151;
    }
    .color-1296db{
        color: #1296db;
    }
    .color-649EFF{
        color: #649EFF;
    }
</style>
